import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Events from '../../../Components/event';

import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';

import { ArrowLong } from '../../../../assets/img/svg/icons';
import { DetailSlider } from '../../../../assets/img/svg/details';
import { EventInterface } from '../../../Services/types';

interface ListInterface {
    events: EventInterface[],
    ano: Number,
    setAno: Function,
}

const ListSection: React.FC<ListInterface> = ({events, ano, setAno}: ListInterface) => {
    const startYear = 2023;
    const year = new Date().getFullYear();
    const years = Array.from({ length:  year - startYear + 1 }, (_, i) => year - i);

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const currentYear = searchParams.get('ano');
    setAno(currentYear);

    useEffect(() => {
        if (currentYear && !isNaN(parseInt(currentYear, 10))) {
            setAno(parseInt(currentYear, 10));
        }
    }, [currentYear, setAno]);

    const initialIndex = currentYear && !isNaN(parseInt(currentYear, 10))
        ? years.indexOf(parseInt(currentYear, 10))
        : Math.floor(years.length / 2);

    return (
        <section className='pt-4 pb-12'>
            <div className="max-w-screen-xl mx-auto px-4 pt-6 md:pt-0">
                <Swiper
                    loop
                    className='relative z-10 max-w-screen-sm mx-auto'
                    modules={[Navigation]}
                    initialSlide={initialIndex}
                    navigation={{
                        prevEl: '.swiper-prev',
                        nextEl: '.swiper-next',
                    }}
                    breakpoints={{
                        767: { slidesPerView: 1 },
                        991: { slidesPerView: 3 },
                    }}
                >
                    {years.map((year) => {
                        const isActive = String(ano) === String(year);
                        return (
                            <SwiperSlide key={year} className='flex justify-center items-center -z-10 pb-3'>
                                <a href={`/eventos-realizados?ano=${year}`} title={`${year}`} 
                                    className={`after:content-[''] after:h-4 after:w-4 after:rotate-45 after:bg-main-blue after:absolute after:left-1/2 after:-translate-x-1/2 after:opacity-0 after:-bottom-2 relative py-2 rounded-full ${isActive ? 'bg-main-blue text-white  font-semibold text-xl after:!opacity-100 px-8' : ''}`}>
                                    {year}
                                </a>
                            </SwiperSlide>
                        );
                    })}

                    <div className="swiper-prev z-40 absolute top-3 left-0 cursor-pointer group">
                        <ArrowLong className='fill-main-pink -scale-x-100 transition-all duration-200 group-hover:fill-main-blue' />
                    </div>

                    <div className="swiper-next z-40 absolute top-3 right-0 cursor-pointer group">
                        <ArrowLong className='fill-main-pink transition-all duration-200 group-hover:fill-main-blue' />
                    </div>
                </Swiper>

                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-2 max-w-screen-lg mx-auto">
                    {events.length > 0 ? 
                        events.map((event) => (
                            <div key={event.id} className="group p-8 relative max-w-[340px] overflow-hidden justify-self-center">
                                <Events slug={event.slug} local={event.local} title={event.titulo} type={event.tipo} date={event.data} thumbnail={event.thumbnail} />
                                <DetailSlider className='opacity-0 absolute bottom-0 left-0 w-full h-80 pointer-events-none transition-all duration-200 group-hover:opacity-100' />
                            </div>
                        ))
                    :
                        <div className='mt-10 text-center md:col-span-2 lg:col-span-3'>
                            Não foi encontrado nenhum evento.
                        </div>
                    }
                </div>
            </div>
        </section>
    );
};

export default ListSection;
